import axios from 'axios'

const state = {
    server_info: null,
    text_search_input: null,
    channel: 1,
    text_search_done: false,

}

const mutations = {
    setServerInfo: (state, info) => state.server_info = info,
    setChannel: (state, num) => state.channel = parseInt(num),
    setTextSearchInput: (state, text_search_input) => state.text_search_input = text_search_input,
    setTextSearchDone: (state, text_search_done) => state.text_search_done = text_search_done
}

const getters = {
    server_info: (state) => state.server_info,
    channel: (state) => state.channel,
    text_search_input: (state) => state.text_search_input,
    text_search_done: (state) => state.text_search_done,

}

const actions = {
    async changeCurrentChannel({commit}, num){
      commit('setChannel', num)
    },
    async searchInputData({commit}, text){
        let text_search_cleared = (text === undefined || text === null || text === '' || text.match(/[0-9][0-9][0-9][0-9]-[0-9]+-[0-9]+/)) ? true:false
        // console.log('Clllllllllllllllllllleeeeeeeeeeeeeeeeeeeeeeeaaaaaaaaaaaaaars A: ', text_search_cleared)
        // console.log('Clllllllllllllllllllleeeeeeeeeeeeeeeeeeeeeeeaaaaaaaaaaaaaars B: ', text)
        // console.log('Clllllllllllllllllllleeeeeeeeeeeeeeeeeeeeeeeaaaaaaaaaaaaaars C: ', new String(text).match(/[0-9][0-9][0-9][0-9]-[0-9]+-[0-9]+/))
        commit('setTextSearchDone', !text_search_cleared)
        commit('setTextSearchInput', text)
    },
    async fetchServerInfo({ commit }){
        const response = await axios.get(`https://pbs12.org/schedule_rest.php?/info`)
        commit('setServerInfo', response.data)
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}